import { render, staticRenderFns } from "./OptionsFormApi.vue?vue&type=template&id=612659b8&"
import script from "./OptionsFormApi.vue?vue&type=script&lang=js&"
export * from "./OptionsFormApi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports